import { ExclamationTriangleIcon, LinkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { systemTitle, systemCustomer, systemAddress } from "./systemPresentation";

export default function SystemDuplicateWarning({ system, onReview }) {
  const { t } = useTranslation();
  const duplicates = system.serial_duplicates;
  if (!duplicates?.count || !duplicates.recommended || !duplicates.candidates?.length) return null;
  const recommended = duplicates.recommended;
  const keepCurrent = String(recommended.id) === String(system.id);
  return <details className="mx-5 mb-4 rounded-xl border border-amber-200 bg-amber-50 text-amber-950">
    <summary className="cursor-pointer px-3 py-3 text-sm font-semibold marker:text-amber-600">
      <ExclamationTriangleIcon className="mr-1 inline h-4 w-4" aria-hidden="true" />
      {t("customer.systems.duplicates_count", { count: duplicates.count })}
    </summary>
    <div className="space-y-3 border-t border-amber-200/70 px-3 py-3 text-xs leading-5">
      <p>{t("customer.systems.duplicates_hint")}</p>
      <p className="font-semibold">{t("customer.systems.duplicates_recommend", { id: recommended.id, title: systemTitle(recommended, t("System")) })}</p>
      <p className="text-amber-900">{t("customer.systems.duplicates_reason")}</p>
      <ul className="space-y-2">{duplicates.candidates.map((candidate) => <li key={candidate.id} className="rounded-lg border border-amber-200 bg-white/80 p-3">
        <p className="break-words font-semibold">{systemTitle(candidate, t("System"))} · #{candidate.id}</p>
        <p className="break-words text-slate-600">{systemCustomer(candidate, t("customer.systems.no_customer"))}</p>
        {systemAddress(candidate) && <p className="break-words text-slate-600">{systemAddress(candidate)}</p>}
        {duplicates.can_merge && <button type="button" className="mt-2 inline-flex min-h-[40px] items-center gap-2 font-semibold text-[#0B3A78] underline" onClick={() => onReview(keepCurrent ? candidate : system, keepCurrent ? system : candidate)}>
          <LinkIcon className="h-4 w-4 shrink-0" />{t("customer.systems.duplicates_review", { id: candidate.id })}
        </button>}
      </li>)}</ul>
      {duplicates.count > duplicates.candidates.length && <p>{t("customer.systems.duplicates_more", { count: duplicates.count - duplicates.candidates.length })}</p>}
    </div>
  </details>;
}
